import { IComparer } from './IComparer';

export class CompositionComparerBuilder<T> {
    buildComparer(...comparers: IComparer<T>[]): IComparer<T> {
        return {
            compare: (x, y) => {
                for (const comparer of comparers) {
                    const result: number = comparer.compare(x, y);

                    if (result !== 0) {
                        return result;
                    }
                }

                return 0;
            },
        };
    }
}
